Controller = App.loadClass 'core::Angular/Controller'

class exports.DownloadController extends Controller

    constructor: (@scope, @transitions, @repo) ->
        super(@scope, @transitions)

        @scope.step.title = 'Download'
        @scope.step.next = @next
        @scope.step.previous = @previous

        @scope.placeholder = 'Loading duplicate fields...'
        @scope.remaining_duplicates = []

        # load data
        @loadRemainingDuplicates()

    previous: () =>
        @scope.goToStep('farm_field')

    next: () =>
        @repo.launchPsr(@scope.selected, @scope.step)

    loadRemainingDuplicates: () =>
        @scope.remaining_duplicates = []
        for field in @scope.selected.duplicate_fields
            # We don't want to change the underlying objects, but we need to be
            # able to exclude years that were resolved.
            copy = $.extend true, {}, field

            # exclude any years that were resolved (no longer contain
            # duplicate results)
            for year, arr of copy.survey_results
                if arr.length is 1
                    delete copy.survey_results[year]

            # if at least one year still has duplicates, include the field
            if Object.keys(copy.survey_results).length > 0
                @scope.remaining_duplicates.push copy

        @scope.placeholder = 'No duplicate fields to display'
